// ---------------------------------------------------------------------------
// Briefing Type — shared constants for PROJ-22
// Used across new-briefing form, briefing view, history, admin pages
// ---------------------------------------------------------------------------

export type BriefingType = 'standard' | 'benefits' | 'ma';

export interface BriefingTypeInfo {
  value: BriefingType;
  label: string;
  shortLabel: string;
  description: string;
  /** Tailwind classes for colored badge */
  badgeClass: string;
  /** Tailwind classes for tile card when selected */
  tileActiveClass: string;
  /** Tailwind classes for tile card border on hover */
  tileBorderClass: string;
}

export const BRIEFING_TYPES: Record<BriefingType, BriefingTypeInfo> = {
  standard: {
    value: 'standard',
    label: 'Risiko- & Vertriebsanalyse',
    shortLabel: 'Standard',
    description:
      'Umfassende Analyse von Unternehmensrisiken, Versicherungsbedarf und Vertriebschancen.',
    badgeClass:
      'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800/40 dark:text-gray-400 dark:border-gray-700',
    tileActiveClass: 'border-primary bg-primary/5 ring-2 ring-primary/20',
    tileBorderClass: 'hover:border-primary/40',
  },
  benefits: {
    value: 'benefits',
    label: 'bAV/bKV Spezial',
    shortLabel: 'bAV/bKV',
    description:
      'Spezialisierte Analyse für betriebliche Altersvorsorge (bAV) und betriebliche Krankenversicherung (bKV).',
    badgeClass:
      'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-800',
    tileActiveClass: 'border-blue-500 bg-blue-50 ring-2 ring-blue-200 dark:bg-blue-950/30 dark:ring-blue-800',
    tileBorderClass: 'hover:border-blue-300 dark:hover:border-blue-700',
  },
  ma: {
    value: 'ma',
    label: 'M&A Due Diligence',
    shortLabel: 'M&A',
    description:
      'Due-Diligence-Analyse für Unternehmenstransaktionen: Risikobewertung, Haftungsanalyse, Versicherungsbedarf bei M&A.',
    badgeClass:
      'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-800',
    tileActiveClass: 'border-amber-500 bg-amber-50 ring-2 ring-amber-200 dark:bg-amber-950/30 dark:ring-amber-800',
    tileBorderClass: 'hover:border-amber-300 dark:hover:border-amber-700',
  },
};

export const BRIEFING_TYPE_VALUES: BriefingType[] = ['standard', 'benefits', 'ma'];

/** Parse a string to BriefingType, defaulting to 'standard' for invalid values */
export function parseBriefingType(value: string | null | undefined): BriefingType {
  if (value === 'benefits' || value === 'ma') return value;
  return 'standard';
}

/** All tab options including "Alle" for history/admin views */
export type BriefingTypeFilter = 'all' | BriefingType;

export const BRIEFING_TYPE_TAB_OPTIONS: Array<{ value: BriefingTypeFilter; label: string }> = [
  { value: 'all', label: 'Alle' },
  { value: 'standard', label: 'Standard' },
  { value: 'benefits', label: 'bAV/bKV Spezial' },
  { value: 'ma', label: 'M&A Due Diligence' },
];
